import http from './http'

const profissionalService = {
  getAll: page => http.get(`/profissionais?page=${page}`).then(result => result.data),
  getAllWithoutPagination: () => http.get(`/profissionaisall`).then(result => result.data),
  getAllZero: () => http.get(`/profissionaiszero`).then(result => result.data),
  getAllZeroSem: () => http.get(`/profissionaiszerosemtodos`).then(result => result.data),
  getAllAtivos: page => http.get(`/profissionais/ativos/?page=${page}`),
  getById: id => http.get(`/profissionais/${id}`).then(result => result.data.data),
  getByIdAtivo: id => http.get(`/profissionais/ativos/${id}`).then(result => result.data.data),
  getByNome: (str, page) => http.get(`/profissionaisdescr/${str}?page=${page}`).then(result => result.data),
  getByNomeAtivo: str => http.get(`/profissionais/ativos/${str}`).then(result => result.data),
  getProfissionaisHabilitados: () => http.get(`/profissionaishabilitados`).then(result => result.data),

  delete: id => http.delete(`/profissionaisdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/profissionais`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/profissionais/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default profissionalService
